import React from 'react';
import { Link } from 'react-router-dom';
import { linkToRecord } from 'ra-core';
import { createStyles, withStyles } from '@material-ui/core/styles';

const styles = createStyles({
  fields: {
    whiteSpace: 'nowrap'
  }
});

type Props = {
  baseName?: string,
  classes: any,
  identifier?: string,
  record: any,
  resourceName?: string,
  source: string,
  target?: string
};

const TextLink = (props: Props) => {
  const baseName = props.resourceName ? props.record[props.resourceName] : props.baseName
  const id = props.identifier ? props.record[props.identifier] : props.record.id;
  let linkName = props.record[props.source].toString();
  const maxLength = 75;

  if (props.record[props.source].length > maxLength) {
    linkName = linkName.substr(0, maxLength) + '...';
  }

  return <Link
    className={props.classes.fields}
    target={props.target}
    to={`/${linkToRecord(baseName, id)}`}>
    {linkName}
  </Link>;
};

export default withStyles(styles)(TextLink);



// WEBPACK FOOTER //
// ./src/views/Common/Utils/TextLink.tsx